module.exports = __webpack_public_path__ + "static/img/function-1.04c4908.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/function-1.png
// module id = 6fyO
// module chunks = 0